export enum MessageBoxType {
    success,
    errorLog,
    error,
    empty,
}
